<div class="ark-toast-container mt-2" [ngClass]="notification.config.toastClass">
  <!--#region Title/message/icon-->
  <div class="row ark-toast-content" [ngClass]="{'mt-3': notification.config.toastClass === 'ark-informationWithHtml'}">
    <div class="col-auto">
      @switch (notification.config.toastClass) {
        @case ('ark-toast-success') {
          <i class="fas fa-check-circle"></i>
        }
        @case ('ark-toast-alert') {
          <i class="fas fa-exclamation-circle"></i>
        }
        @case ('ark-toast-error') {
          <i class="fas fa-times-circle"></i>
        }
        @case ('ark-toast-information') {
          <i class="fas fa-info-circle"></i>
        }
        @case ('ark-toast-informationWithHtml') {
          <i class="fas fa-info-circle"></i>
        }
        @case ('ark-toast-successWithHtml') {
          <i class="fas fa-toggle-on f-85"></i>
        }
        @case ('ark-toast-alertWithHtml') {
          <i class="fas fa-toggle-on f-85"></i>
        }
      }
    </div>

    <div class="col-10 p-0">
      <div class="row m-0">
        <div class="col-12 p-0 d-flex justify-content-between">
          <h3 class="ark-h3" [ngClass]="{'mt-4': notification.config.toastClass === 'ark-toast-informationWithHtml'}">{{notification.title}}</h3>
          @if (options.closeButton) {
            <a class="btn ark-btn-action close" (click)="remove()">
              <span><i class="fal fa-times"></i></span>
            </a>
          }
        </div>
        @if (notification.message && notification.config.enableHtml) {
          <div class="col-12 p-0 ark-message"
            [innerHTML]="notification.message">
          </div>
        }
        @if (notification.message && !notification.config.enableHtml) {
          <div class="col-12 p-0">
            <p class="ark-message">{{notification.message}}</p>
          </div>
        }
      </div>
    </div>
  </div>
  <!--#endregion-->

  <!--#region Progress-->
  <div class="row ark-toast-progress">
    <div class="ark-toast-status-progress my-2" [style.width]="width() + '%'"></div>
  </div>
  <!--#endregion-->

</div>
